import { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'
import Icon from 'components/ui/icon'

import PersonCell from 'components/ui/personCell'
import StatusBadge from 'components/ui/statusBadge'
import { AdminUser } from '../types'

const roleLabels: Record<string, string> = {
  ROLE_DOCTOR: 'Médico',
  ROLE_HOSPITAL_ADMIN: 'Admin hospital',
  ROLE_ADMIN: 'Admin',
}

const UsersTable: FunctionComponent<{ users: AdminUser[] }> = ({ users }) => (
  <div className="table-wrap">
    <Table hover>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Email</th>
          <th>Perfil</th>
          <th>Bi Médico</th>
          <th className="actions-col">
            <span className="visually-hidden">Ações</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {users.map((user) => (
          <tr key={user.id}>
            <td>
              <PersonCell name={user.name} />
            </td>
            <td className="muted">{user.email}</td>
            <td className="muted">{roleLabels[user.role] || user.role}</td>
            <td className={user.displayBi ? undefined : 'muted'}>
              {user.displayBi ? (
                <StatusBadge tone="success">Exibido</StatusBadge>
              ) : (
                <span aria-label="Não exibido">—</span>
              )}
            </td>
            <td className="actions-col">
              <div className="row-actions">
                <Link to={`/users/${user.id}`} className="row-action">
                  <Icon name="edit" size={14} />
                  Editar
                </Link>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
)

export default UsersTable
